import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/shared/modules/material/material-module.module';

@Component({
  selector: 'app-edit-profile-success-change',
  templateUrl: './edit-profile-success-change.component.html',
  styleUrls: ['./edit-profile-success-change.component.scss'],
  standalone: true,
  imports: [MaterialModule, TranslateModule],
})
export class EditProfileSuccessChangeComponent {
  constructor(
    public dialogRef: MatDialogRef<EditProfileSuccessChangeComponent>
  ) {}
}
